var _defs, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailRead(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.544,6.2l-9-5.848a1,1,0,0,0-1.092,0L.456,6.2A1,1,0,0,0,0,7.044V16a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V7.044A1,1,0,0,0,19.544,6.2ZM19,16a.982.982,0,0,1-.071.352L12.4,12,19,7.6ZM10,1.194h0L18.51,6.726,11.5,11.4l-1.223-.815a.5.5,0,0,0-.554,0L8.5,11.4,1.489,6.725ZM1.071,16.352A.976.976,0,0,1,1,16V7.6L7.6,12ZM2,17c-.026,0-.048-.013-.074-.015L10,11.6l8.076,5.384c-.026,0-.049.015-.075.015Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRead);
export default __webpack_public_path__ + "static/media/Email_Read.655a778c14e0a5b02c97036f44decc3d.svg";
export { ForwardRef as ReactComponent };